import axiosServices from './request';

const UserApi = axiosServices('/usercenter/v1.0');

export default {
  // 登录
  login: UserApi('post', 'user/login4Rays7'),
  /** 地区码 */
  listPhoneArea: UserApi('get', 'common/listPhoneArea'),

  // 获取用户信息
  getUserInfo: UserApi('get', 'user/getInfo'),
  // 重置密码
  getByPhone: UserApi('get', 'party/getByPhone'),
  // 通过手机验证码修改重置密码
  updatePwdByMobile: UserApi('post', 'user/updatePwdByMobile4Rays7'),
  /** 获取编辑信息 */
  getAdviserInfo: UserApi('get', 'adviser/getInfo'),
  /** 获取可选渠道 */
  getChannels: UserApi('get', 'channel/getByAdviser'),
  // 获取编辑端token
  getAdviserToken4Rays7: UserApi('get', 'user/getAdviserToken4Rays7')
};
